<template>
  <div class="component">
    <h1>Mentions légales</h1>
    <h2>Le fournisseur de service</h2>
    <h3>Éditeur du site Internet&nbsp;:</h3>
    <p>SIACI SAINT HONORE – Groupe DIOT-SIACI – Société de Courtage d’Assurance et de Réassurance. Siège social : Season – 39, rue Mstislav Rostropovitch – 75815 Paris cedex 17 – France – Tél. : +33 (0)1 4420 9999. SAS – Capital : 180.357.531,20 € – RCS Paris 572 059 939 – APE 6622 Z – N° TVA : FR 54 572 059 939. N° ORIAS : 07 000 771 (orias.fr) – Sous le contrôle de / Regulated by ACPR – 4 place de Budapest – CS 92459 – 75436 Paris cedex 09 – France. Réclamations / Complaint : SIACI SAINT HONORE – Service réclamations – 23, allées de l’Europe – 92587 Clichy cedex – France.</p>
    <h3>Directeur de la publication&nbsp;:</h3>
    <p>Frédéric Grand, Directeur Général MSH &amp; Protection Sociale et Conseil France et International – Diot-Siaci</p>
    <h3>Hébergement&nbsp;:</h3>
    <p><strong>Infogérance 1 &nbsp;:</strong></p>
    <p>
      Diot-Siaci Technologies<br />
      Season<br />
      39, rue Mstislav Rostropovitch<br />
      75017 Paris<br />
      France
    </p>
    <p><strong>Infogérance 2&nbsp;:</strong></p>
    <p>
      Sopra Steria Group<br />
      PAE DES GLAISINS, 3 RUE DU PRE FAUCON,<br />
      74000 ANNECY France
    </p>
    <p><strong>Hébergement&nbsp;(Activité Santé) :</strong></p>
    <p>
      Data 4 Services<br />
      6 RUE DE LA TREMOILLE,<br />
      75008 PARIS<br />
      France
    </p>
    <p>
      <strong>Hébergement <em>(Activité Santé et Prévoyance pour certains cas spécifiques)&nbsp;: </em><br /> </strong>
    </p>
    <p>
      Partitio<br />
      8 RUE CLAUDE-MARIE PERROUD,<br />
      31100 TOULOUSE<br />
      France
    </p>
    <h3>Droits d’auteur – copyright</h3>
    <p>
      ©Vivinter 2024. Tous les éléments de toute nature (images fixes, images animées, bases de données, marques, illustrations, logos, dessins, modèles, mise en page, documents téléchargeables) contenus dans ce site sont protégés en tant qu’œuvre de l’esprit par la législation française et internationale sur le droit d’auteur et la propriété intellectuelle. Ces éléments restent la propriété exclusive de Vivinter, sauf mentions particulières. A ce titre, sauf autorisation préalable et écrite, toute reproduction, représentation, adaptation, modification partielle ou intégrale de tout élément composant le site, par quelque moyen que ce soit, est interdite sous peine de poursuite judiciaire. Les marques et logos reproduits sur notre site internet sont déposés. Toute reproduction, réédition ou redistribution totale ou partielle des marques ou logos, par quelque moyen que ce soit, sans autorisation préalable et écrite est interdite, au sens de l’article L.713-2 du Code de la propriété
      intellectuelle.
    </p>
    <h3>Loi applicable</h3>
    <p>Le présent site est régi par la loi française. Compétence est donnée aux tribunaux français pour tout règlement de litige.</p>
    <h3>Responsabilité</h3>
    <p>Les informations contenues dans ce site n’ont aucune valeur contractuelle et peuvent être modifiées à tout moment par Vivinter. Vivinter ne saurait garantir l’exactitude des informations contenues dans ce site ; en aucun cas la responsabilité de la société Vivinter ne pourra être mise en cause du fait de l’utilisation des informations diffusées ce site ou de l’absence d’informations spécifiques.</p>
    <h2>Protection des données personnelles</h2>
    <p>Diot-Siaci situé à Season, 39 rue Mstislav Rostropovitch 75815 Paris cedex 17. met en oeuvre un traitement de données à caractère personnel nécessaire à votre identification formelle pour accéder à un espace sécurisé, à l’émission d’une offre d’assurance ou d’un contrat, sa gestion et son suivi et à la réalisation des diligences réglementaires en matière de lutte contre le blanchiment et de financement du terrorisme. A cet égard, les données collectées sont toutes obligatoires.</p>
    <p>Les destinataires de vos données à caractère personnel sont : l’assureur porteur de risques, les différentes entités composant Diot-Siaci, et les prestataires participant à la gestion du contrat d’assurance.</p>
    <p>Vos données à caractère personnel pourront aussi être communiquées, le cas échéant, à France Travail pour systématiser et sécuriser la collecte des preuves de bénéfice du régime d’assurance chômage afin d’améliorer la détection, la validation et la gestion de la portabilité de vos droits en santé issus de l’article 14 de l’ANI du 11 janvier 2008, complété par la loi de sécurisation de l’emploi du 14 juin 2013, dans le cas où vous seriez en situation de chômage.</p>
    <p>Vos données à caractère personnel seront conservées pendant toute la durée nécessaire au service de gestion telle que prescrite par les lois applicables en la matière. Vous disposez à tout moment d’un droit d’accès, de rectification, ou d’effacement ou de limitation ou d’opposition et de portabilité de vos données à caractère personnel ainsi que du droit d’organiser des directives qui prendraient effet postérieurement à votre décès.</p>
    <p>Vous disposez du droit d’introduire une réclamation auprès d’une autorité de contrôle en charge de la protection des données personnelles. Le Délégué à la Protection des Données de Diot Siaci est <span class="ui-provider ee aym ayn ayo ayp ayq ayr ays ayt ayu ayv ayw ayx ayy ayz aza azb azc azd aze azf azg azh azi azj azk azl azm azn azo azp azq azr azs azt" dir="ltr">DPO du groupe DIOT SIACI</span>, Season, 39 rue Mstislav Rostropovitch 75815 Paris cedex 17.</p>
  </div>
</template>

<script>
export default {
  name: "UserInputForm",
  data() {},
  created() {},
  mounted() {},
  computed: {},
  methods: {},
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/_variables.scss";

.component {
  page-break-inside: avoid !important;
  font: normal normal normal 14px/16px "csr" !important;
  line-height: normal;

  h1 {
    font-size: 22px;
    font-family: "csb";
  }

  h2 {
    font-size: 18px;
    font-family: "csb";
  }

  h3 {
    font-size: 16px;
    font-family: "csb";
  }

  p {
    margin-bottom: 0.5rem;
  }
}
</style>
